module.exports = __webpack_public_path__ + "img/off_.8cb821ab.svg";